<script setup>
import { computed, toRefs } from "vue";
import ButtonWithSpinner from "@/components/forms/SharedComponents/ButtonWithSpinner.vue";
import ArrowRight from "@/components/shared/icons/ArrowRight.vue";
import PartyPopperIcon from "@/components/svg-icons/PartyPopperIcon.vue";

const props = defineProps({
  application: {
    type: Object,
    default: () => {},
    required: true,
  },
});

const { application } = toRefs(props);

const applicationId = computed(() => application?.value?.applicationId?.value);
const personalized = computed(() => !application.value?.isNonConfigurableSession?.value);
const requiresApplication = computed(() => application.value?.requiresApplication?.value);

const subtitleText = computed(() => {
  if (personalized.value) {
    return "Thank you for personalizing your experience with us. Learn more about next steps by clicking ‘Continue’ below.";
  } else if (requiresApplication.value) {
    return "Thank you for applying with us. Learn more about next steps by clicking ‘Continue’ below.";
  }

  return "Thank you for registering with us. Learn more about next steps by clicking ‘Continue’ below.";
});

const destination = computed(() => {
  return {
    name: "experience-detail",
    params: { applicationId: applicationId.value },
  };
});
</script>
<template>
  <div
    class="text-indigo-base text-center bg-white w-5/6 px-4 pb-4 mx-auto max-w-2xl sm:px-8 sm:pb-8 mt-4"
  >
    <div class="flex flex-col items-center gap-6">
      <PartyPopperIcon class="xs:hidden md:flex mt-8 w-1/4" />
      <h1 class="font-bold text-3xl uppercase">
        You're on your way! 🥳🎉
      </h1>
      <h2 class="text-sm">
        {{ subtitleText }}
      </h2>
    </div>
    <div class="flex flex-col mt-8 items-center w-full">
      <router-link :to="destination" class="w-full">
        <ButtonWithSpinner
          id="continueButton"
          ref="continueButton"
          data-cy="continueButton"
          variant="secondary"
          variant-type="block"
          button-height="min-h-[58px] md:min-h-[60px] mt-4"
          :grey-disabled-class="true"
          class="w-full"
        >
          <div class="flex items-center justify-center">
            <span class="pr-3 uppercase">
              Continue
            </span>
            <ArrowRight custom-class="w-4 h-4" />
          </div>
        </ButtonWithSpinner>
      </router-link>
    </div>
  </div>
</template>
